class subscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onClick = (event) => {
      const option = event.target.closest("[data-option]");
      if (option) this.select(option.dataset.option);
    };

    this.onKeydown = (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      const option = event.target.closest("[data-option]");
      if (!option) return;
      event.preventDefault();
      this.select(option.dataset.option);
    };

    this.addEventListener("click", this.onClick);
    this.addEventListener("keydown", this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
    this.removeEventListener("keydown", this.onKeydown);
  }

  get wrapper() {
    return this.querySelector(".purchase_options_wrapper");
  }

  get subscribeOption() {
    return this.querySelector('[data-option="subscribe_and_save"]');
  }

  get oneTimeOption() {
    return this.querySelector('[data-option="one_time"]');
  }

  get input() {
    return this.querySelector('input[name="selling_plan"]');
  }

  get purchaseOption() {
    return this.wrapper?.dataset.purchaseOption;
  }

  get sellingPlanId() {
    return this.subscribeOption?.dataset.sellingPlanId || "";
  }

  select(option) {
    if (option === "subscribe_and_save" && !this.sellingPlanId)
      option = "one_time";

    const isSubscription = option === "subscribe_and_save";

    this.wrapper.dataset.purchaseOption = option;
    this.setSelected(this.subscribeOption, isSubscription);
    this.setSelected(this.oneTimeOption, !isSubscription);

    this.input.value = isSubscription ? this.sellingPlanId : "";
    this.input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  setSelected(option, selected) {
    if (!option) return;
    option.classList.toggle("is-selected", selected);
    option.setAttribute("aria-checked", selected);
  }
}

if (!customElements.get("subscription-widget")) {
  customElements.define("subscription-widget", subscriptionWidget);
}
